import styled from 'styled-components';
import { IonContent } from '@ionic/react';

export const IonContentWrapper = styled(IonContent)`
  ion-grid {
    padding: 0;
  }

  .more-results-container {
    display: flex;
    justify-content: center;
    border-width: 0;
    border-style: dashed;
    border-color: var(--ion-color-dark);
    border-top-width: 1px;
  }
`;
